import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { ModalService } from '../../services/modal.service';
import { TelefoneDialogComponent } from '../../home/telefone-dialog.component';

@Component({
   selector: 'app-lojas',
   imports: [CommonModule, MatDialogModule, MatIcon],
   standalone: true,
   templateUrl: './lojas.component.html',
   styleUrls: ['./lojas.component.scss']
})
export class LojasComponent {
   unidades = [
      {
         nome: 'Matriz Dores',
         endereco: 'Av. Nossa Senhora das Dores, 2347',
         foto: '../../assets/unidades/home/DORES.webp',
         telefone: '(55) 3033-7400',
         linkMapa: 'https://maps.app.goo.gl/Ek3p6J7AC6fUXiBDA'
      },
      {
         nome: 'Agência Centro',
         endereco: 'Rua Venâncio Aires, 1349 loja 2',
         foto: '../../assets/unidades/home/agencia_centro_menor.webp',
         telefone: '(55) 3311-6300',
         linkMapa: 'https://maps.app.goo.gl/3DRt2taDBvqDNhth8'
      },
      {
         nome: 'Agência Camobi',
         endereco: 'Av. Prefeito Evandro Behr, 7300',
         foto: '../../assets/unidades/home/camobi-loja.webp',
         telefone: '(55) 3026-6300',
         linkMapa: 'https://maps.app.goo.gl/49PBrXosac3uG13A6'
      },
      {
         nome: 'Agência Hélvio Basso',
         endereco: 'Av. Hélvio Basso, 535',
         foto: '../../assets/unidades/home/helvio_basso.webp',
         telefone: '(55) 3290-6301',
         linkMapa: 'https://maps.app.goo.gl/8z4nC5djJSvmigsW8'
      }
   ];

   constructor(private modalService: ModalService) { }

   openTelefone(nome: string, telefone: string) {
      this.modalService.open(TelefoneDialogComponent, { nome, telefone });
   }

   openTelefoneMobile(nome: string, telefone: string, linkMapa: string) {
      this.modalService.open(TelefoneDialogComponent, { nome, telefone, linkMapa });
   }
}
